var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 12.3047C6.5148 12.3047 5.33203 13.4875 5.33203 14.9414V22.0898C5.33203 23.5438 6.5148 24.7266 7.96875 24.7266C9.4227 24.7266 10.6055 23.5438 10.6055 22.0898V14.9414C10.6055 13.4875 9.4227 12.3047 7.96875 12.3047Z",
    fill: "#002555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57422 14.9414C3.57422 14.6879 3.60768 14.443 3.6491 14.2012C2.58984 14.5435 1.81641 15.5274 1.81641 16.6993V20.3321C1.81641 21.5039 2.58984 22.4878 3.6491 22.8302C3.60768 22.5883 3.57422 22.3434 3.57422 22.0899V14.9414Z",
    fill: "#002555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 12.3047C20.5773 12.3047 19.3945 13.4875 19.3945 14.9414V22.0898C19.3945 23.5438 20.5773 24.7266 22.0312 24.7266C22.2955 24.7266 22.5458 24.6757 22.7866 24.603C22.4595 25.6876 21.4632 26.4844 20.2734 26.4844H17.4748C17.1108 25.4636 16.1443 24.7266 15 24.7266C13.5461 24.7266 12.3633 25.9093 12.3633 27.3633C12.3633 28.8172 13.5461 30 15 30C16.1443 30 17.1108 29.263 17.4748 28.2422H20.2734C22.6965 28.2422 24.668 26.2707 24.668 23.8477V22.0898V14.9414C24.668 13.4875 23.4852 12.3047 22.0312 12.3047Z",
    fill: "#002555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3513 14.2012C26.3927 14.443 26.4262 14.6879 26.4262 14.9414V22.0899C26.4262 22.3434 26.3927 22.5883 26.3513 22.8302C27.4106 22.4878 28.184 21.5039 28.184 20.3321V16.6993C28.184 15.5274 27.4106 14.5435 26.3513 14.2012Z",
    fill: "#002555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C7.73016 0 1.81641 5.91375 1.81641 13.1836V13.206C2.34006 12.8096 2.94592 12.5195 3.61447 12.3896C4.02527 6.46002 8.96801 1.75781 15 1.75781C21.032 1.75781 25.9747 6.46002 26.3855 12.3895C27.054 12.5194 27.6599 12.8096 28.1836 13.206V13.1836C28.1836 5.91375 22.2698 0 15 0Z",
    fill: "#002555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.1904981c339bd30c09879adeb2758103.svg";
export { ForwardRef as ReactComponent };